import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Box, Typography, Grid, Container, TextField, Button, Paper } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import AnimatedSection from '../components/AnimatedSection';
const contact = '/assets/contact.jpeg';

export default function ContactPage() {
  return (
    <Box>
      <Helmet>
        <title>Contact Splash Beauty Lounge | Salon in Asilmetta, Vizag</title>
        <meta name="description" content="Book your appointment with Splash Beauty Lounge, Asilmetta, Vizag. Call us for hair, skin, bridal and wellness services today." />
        <meta name="keywords" content="contact Splash Beauty Lounge, salon phone number Vizag, beauty parlour Asilmetta, salon location Vizag, book salon appointment Vizag" />
      </Helmet>
      <Box
        sx={{
          position: 'relative',
          backgroundImage: `url(${contact})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          py: { xs: 8, md: 12 },
          textAlign: 'center',
          color: '#fff',
          overflow: 'hidden',
          '&::before': {
            content: '""',
            position: 'absolute',
            inset: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
          },
        }}
      >
        <Box sx={{ position: 'relative', zIndex: 1 }}>
          <Typography
            variant="h2"
            sx={{
              color: '#fff',
              fontFamily: '"Playfair Display", serif',
              fontSize: { xs: '2.5rem', md: '3.5rem' },
              mb: 1.5,
              textShadow: '0 2px 10px rgba(0,0,0,0.3)',
            }}
          >
            Contact Us
          </Typography>
          <Typography
            sx={{
              fontFamily: '"Lato", sans-serif',
              color: 'rgba(255,255,255,0.9)',
              fontSize: '1.1rem',
              maxWidth: '600px',
              mx: 'auto',
              px: 2,
            }}
          >
            Get in touch with us for appointments and inquiries
          </Typography>
        </Box>
      </Box>

      <Container maxWidth="lg" sx={{ py: 8 }}>
        <Grid container spacing={5}>
          <Grid item xs={12} md={5}>
            <AnimatedSection>
              <Typography
                variant="h5"
                sx={{ fontFamily: '"Playfair Display", serif', color: '#1a1a1a', mb: 4 }}
              >
                Visit Us
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                <Paper elevation={0} sx={{ border: '1px solid #eee', borderRadius: 2, p: 3 }}>
                  <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
                    <Box
                      sx={{
                        width: 44, height: 44, borderRadius: '50%',
                        backgroundColor: '#fff0f7',
                        display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                      }}
                    >
                      <PhoneIcon sx={{ color: '#FF0099' }} />
                    </Box>
                    <Box>
                      <Typography sx={{ fontFamily: '"Lato", sans-serif', fontWeight: 700, fontSize: '0.9rem', color: '#333', mb: 0.3 }}>
                        Phone
                      </Typography>
                      <Typography sx={{ fontFamily: '"Lato", sans-serif', fontSize: '0.9rem', color: '#888' }}>
                        +91 89776 26223
                      </Typography>
                    </Box>
                  </Box>
                </Paper>

                <Paper 
                  elevation={0} 
                  component="a"
                  href="https://maps.app.goo.gl/SeXD9YXk7YtmbJS3A"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{ border: '1px solid #eee', borderRadius: 2, p: 3, textDecoration: 'none', transition: 'all 0.3s', '&:hover': { borderColor: '#FF0099', boxShadow: '0 4px 15px rgba(255,0,153,0.1)' } }}
                >
                  <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
                    <Box
                      sx={{
                        width: 44, height: 44, borderRadius: '50%',
                        backgroundColor: '#fff0f7',
                        display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                      }}
                    >
                      <LocationOnIcon sx={{ color: '#FF0099' }} />
                    </Box>
                    <Box>
                      <Typography sx={{ fontFamily: '"Lato", sans-serif', fontWeight: 700, fontSize: '0.9rem', color: '#333', mb: 0.3 }}>
                        Address
                      </Typography>
                      <Typography sx={{ fontFamily: '"Lato", sans-serif', fontSize: '0.9rem', color: '#888', lineHeight: 1.6 }}>
                        Opp. Bombay Gaslight Stores,<br />
                        Asilmetta Junction,<br />
                        Visakhapatnam
                      </Typography>
                    </Box>
                  </Box>
                </Paper>

                <Paper elevation={0} sx={{ border: '1px solid #eee', borderRadius: 2, p: 3 }}>
                  <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
                    <Box
                      sx={{
                        width: 44, height: 44, borderRadius: '50%',
                        backgroundColor: '#fff0f7',
                        display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                      }}
                    >
                      <AccessTimeIcon sx={{ color: '#FF0099' }} />
                    </Box>
                    <Box>
                      <Typography sx={{ fontFamily: '"Lato", sans-serif', fontWeight: 700, fontSize: '0.9rem', color: '#333', mb: 0.3 }}>
                        Hours
                      </Typography>
                      <Typography sx={{ fontFamily: '"Lato", sans-serif', fontSize: '0.9rem', color: '#888' }}>
                        Monday - Sunday<br />
                        9:00AM - 9:00PM
                      </Typography>
                    </Box>
                  </Box>
                </Paper>
              </Box>
            </AnimatedSection>
          </Grid>

          <Grid item xs={12} md={7}>
            <AnimatedSection delay={0.15}>
              <Typography
                variant="h5"
                sx={{ fontFamily: '"Playfair Display", serif', color: '#1a1a1a', mb: 4 }}
              >
                Send Us a Message
              </Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Your Name"
                      variant="outlined"
                      size="small"
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          fontFamily: '"Lato", sans-serif',
                          borderRadius: 1.5,
                          '&:hover fieldset': { borderColor: '#FF0099' },
                          '&.Mui-focused fieldset': { borderColor: '#FF0099' },
                        },
                        '& .MuiInputLabel-root.Mui-focused': { color: '#FF0099' },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Phone Number"
                      variant="outlined"
                      size="small"
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          fontFamily: '"Lato", sans-serif',
                          borderRadius: 1.5,
                          '&:hover fieldset': { borderColor: '#FF0099' },
                          '&.Mui-focused fieldset': { borderColor: '#FF0099' },
                        },
                        '& .MuiInputLabel-root.Mui-focused': { color: '#FF0099' },
                      }}
                    />
                  </Grid>
                </Grid>
                <TextField
                  fullWidth
                  label="Email Address"
                  variant="outlined"
                  size="small"
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontFamily: '"Lato", sans-serif',
                      borderRadius: 1.5,
                      '&:hover fieldset': { borderColor: '#FF0099' },
                      '&.Mui-focused fieldset': { borderColor: '#FF0099' },
                    },
                    '& .MuiInputLabel-root.Mui-focused': { color: '#FF0099' },
                  }}
                />
                <TextField
                  fullWidth
                  label="Service of Interest"
                  variant="outlined"
                  size="small"
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontFamily: '"Lato", sans-serif',
                      borderRadius: 1.5,
                      '&:hover fieldset': { borderColor: '#FF0099' },
                      '&.Mui-focused fieldset': { borderColor: '#FF0099' },
                    },
                    '& .MuiInputLabel-root.Mui-focused': { color: '#FF0099' },
                  }}
                />
                <TextField
                  fullWidth
                  label="Message"
                  variant="outlined"
                  multiline
                  rows={4}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      fontFamily: '"Lato", sans-serif',
                      borderRadius: 1.5,
                      '&:hover fieldset': { borderColor: '#FF0099' },
                      '&.Mui-focused fieldset': { borderColor: '#FF0099' },
                    },
                    '& .MuiInputLabel-root.Mui-focused': { color: '#FF0099' },
                  }}
                />
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: '#FF0099',
                    color: '#fff',
                    borderRadius: '25px',
                    py: 1.2,
                    fontSize: '0.95rem',
                    fontWeight: 700,
                    alignSelf: 'flex-start',
                    px: 4,
                    '&:hover': { backgroundColor: '#CC0077' },
                    boxShadow: '0 4px 15px rgba(255,0,153,0.3)',
                  }}
                >
                  Send Message
                </Button>
              </Box>
            </AnimatedSection>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}